module.exports = __webpack_public_path__ + "img/6.100a56f8.png";